function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationSettings = function SvgNotificationSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 6.4c-1 0-1.8.8-1.8 1.8v.3c-2.2.8-3.7 2.8-3.7 5.2V17l-1.4 2.1c-.4.6-.4 1.3-.1 1.9s.9 1 1.5 1h2.7c0 1.5 1.3 2.8 2.7 2.8 1.5 0 2.7-1.2 2.7-2.8h2.7c.7 0 1.3-.4 1.6-1s.2-1.4-.2-1.9L22.5 17v-3.3c0-2.4-1.5-4.4-3.6-5.2v-.3c.2-.9-.7-1.8-1.7-1.8m1 13.9h-6.5l1.4-1.8.1-.2c.2-.3.3-.7.3-1.1v-3.3c0-2 1.6-3.7 3.6-3.7 2.1 0 3.6 1.7 3.6 3.7v3.3c0 .4.2.8.4 1.1l.1.2 1.3 1.8h-4.3m-1 2.7c-.4 0-.9-.4-.9-.9h1.9c0 .5-.4.9-1 .9",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    transform: "translate(-4 -2)"
  }));
};
export default SvgNotificationSettings;